import Svg, { Path } from 'react-native-svg'

export const TransactionIcon = ({ width = 24, height = 24, color }: any) => {
  return (
    <Svg width={width} height={height} fill="none" viewBox="0 0 24 24">
      <Path
        fill={color}
        fillRule="evenodd"
        d="M4.504 2.005a.5.5 0 00-.5.5v3.994H2v1h2.004v4H2v1h2.004v4H2v1h2.004v4.006a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5h-15zm.5 19v-18h14v18h-14zM14.233 7h-1.647c.24.332.358.714.42 1.043h1.65l-.423 1h-1.269c-.305 1.236-1.506 1.804-2.22 1.878l2.722 3.085h-1.207L9.53 10.921V9.913c1.486.13 2.054-.339 2.27-.87H9.344l.435-1h2.144c-.101-.709-.667-.97-1.183-1.043H9.344l.435-1h4.877l-.423 1zM9 18.019h6v-1H9v1z"
        clipRule="evenodd"
      />
    </Svg>
  )
}
